import axios from "axios";
import api from "../utils/api";
import { detectDeviceOs } from "../utils/deviceOs";
import { getClientIp } from "../utils/clientIp";

// Lets the session list show location and device from sign-in on.
async function announceSession(token) {
  try {
    await axios.post(
      "https://admuserjourney.api.adsctv.net/sessions/hello",
      { platform: "web", device_os: detectDeviceOs(), client_ip: await getClientIp() },
      { headers: { Token: token } }
    );
  } catch {
    // monitoring only
  }
}

export const loginService = {
  login: async (email, password, recaptchaToken) => {
    try {
      const res = await api.post("/login", {
        email,
        password,
        recaptchaToken,
      });

      const data = res.data;

      if (!data?.token || !data?.user) {
        throw new Error("Invalid login response");
      }

      if (data.user.role !== "SUPERADMIN") {
        fetch("https://youtubereader.api.adsctv.net/logout", {
          method: "POST",
          headers: { Token: data.token },
          keepalive: true,
        }).catch(() => {});
        const denied = new Error("This test panel is only available to SUPERADMIN accounts.");
        denied.code = "ROLE_NOT_ALLOWED";
        throw denied;
      }

      // ✅ TEK YERDE STORAGE
      localStorage.setItem("adm_panel_token", data.token);
      localStorage.setItem(
        "adm_panel_user",
        JSON.stringify(data.user)
      );
      announceSession(data.token);

      return data;

    } catch (err) {
      if (err.code === "ROLE_NOT_ALLOWED") throw err;

      if (err.response) {
        throw new Error(
          err.response?.data?.message || "Login failed"
        );
      }

      throw new Error("Network error");
    }
  },

  logout: () => {
    localStorage.removeItem("adm_panel_token");
    localStorage.removeItem("adm_panel_user");
  },

  isAuthenticated: () => {
    return !!localStorage.getItem("adm_panel_token");
  },
};